import { render } from "./FAQList.vue?vue&type=template&id=5879515c&scoped=true&ts=true"
import script from "./FAQList.vue?vue&type=script&lang=ts"
export * from "./FAQList.vue?vue&type=script&lang=ts"

import "./FAQList.vue?vue&type=style&index=0&id=5879515c&lang=scss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5879515c"]])

export default __exports__